"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iosFocusHandler = void 0;
/**
 * Workaround for iOS focus issue.
 * iOS does not allow to focus on an input element outside of the original click handler.
 * As the Textfield does not exist on the dom during the lifetime of the original handler
 * we need to create a dummy input element to receive the focus first.
 * Then we can focus on the target input element.
 * @see https://stackoverflow.com/questions/12204571/mobile-safari-javascript-focus-method-on-inputfield-only-works-with-click
 */
var iosFocusHandler = function (inputRef) {
    // create invisible dummy input to receive the focus first
    var fakeInput = document.createElement('input');
    fakeInput.setAttribute('type', 'text');
    fakeInput.style.position = 'absolute';
    fakeInput.style.opacity = '0';
    fakeInput.style.height = '0';
    fakeInput.style.fontSize = '16px'; // disable auto zoom
    document.body.prepend(fakeInput);
    // focus so that subsequent async focus will work
    fakeInput.focus();
    setTimeout(function () {
        // now we can focus on the target input
        if (inputRef.current) {
            inputRef.current.focus();
        }
        // cleanup
        fakeInput.remove();
    }, 0);
};
exports.iosFocusHandler = iosFocusHandler;
//# sourceMappingURL=deviceSpecificHandlers.js.map